import React, { useEffect, useState } from 'react';
import './FilterModal.css';
import { LogType } from '../interfaces/LogType';
import { loadSharedUsers } from '../firebase/db-settings';
import { SettingsType, UserType } from '../interfaces/SettingsType';
import { FilterType } from '../interfaces/FilterType';
import { loadLocationStats, updateStats } from '../firebase/db-stats';
import LoadingSpinner from './LoadingSpinner';

interface FilterModalProps {
  onClose: () => void;
  onApply: (filters: FilterType[]) => void;
  settings: SettingsType;
}

const FilterModal: React.FC<FilterModalProps> = ({
  onClose,
  onApply,
  settings,
}) => {
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [pilot, setPilot] = useState<string>('');
  const [location, setLocation] = useState<string>('');
  const [mission, setMission] = useState<string>('');

  const [loading, setLoading] = useState(false);

  const [uniquePilots, setUniquePilots] = useState<UserType[]>([]);
  const [uniqueLocations, setUniqueLocations] = useState<string[]>([
    'Orte werden geladen...',
  ]);

  useEffect(() => {
    loadData();
  }, []);
  async function loadData() {
    const sharedUser = await loadSharedUsers(settings);
    if (sharedUser) setUniquePilots(sharedUser);
    const lastFilterString = localStorage.getItem('lastFilter');
    const locationStats = await loadLocationStats();
    if (locationStats)
      setUniqueLocations(locationStats.map((item) => item.location));
    if (lastFilterString) {
      const lastFilter = JSON.parse(lastFilterString);
      setStartDate(lastFilter.startDate);
      setEndDate(lastFilter.endDate);
      setPilot(lastFilter.pilot);
      setLocation(lastFilter.location);
      setMission(lastFilter.mission);
    }
  }
  async function refreshData() {
    setLoading(true);
    await updateStats([{ field: 'location', operator: '==', value: 'all' }]);
    await loadData();
    setLoading(false);
  }

  const handleApply = () => {
    const filters: FilterType[] = [];
    if (pilot != '')
      filters.push({ field: 'pilotId', operator: '==', value: pilot });
    if (mission != '')
      filters.push({ field: 'mission', operator: '==', value: mission });
    if (location != '')
      filters.push({ field: 'location', operator: '==', value: location });
    if (startDate != '')
      filters.push({
        field: 'startTime',
        operator: '>=',
        value: new Date(startDate).toISOString(),
      });
    if (endDate != '')
      filters.push({
        field: 'startTime',
        operator: '<=',
        value: new Date(endDate).toISOString(),
      });
    localStorage.setItem(
      'lastFilter',
      JSON.stringify({ startDate, endDate, pilot, location, mission })
    );
    onApply(filters);
    onClose();
  };

  const handleReset = () => {
    setStartDate('');
    setEndDate('');
    setPilot('');
    setLocation('');
    setMission('');
    localStorage.clear();
    onApply([]);
    onClose();
  };

  return (
    <div className="filter-modal-overlay" onClick={onClose}>
      <div
        className="filter-modal-content filter-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="filter-close-button-filter" onClick={onClose}>
          X
        </button>
        <div className="filter-modal-header">
          <h2>Filter</h2>
        </div>
        <div className="filter-modal-body">
          <div className="filter-modal-left">
            <div className="filter-modal-details">
              <div className="filter-modal-group">
                <div>
                  <strong>Startdatum:</strong>
                  <input
                    type="date"
                    className="filter-modal-input filter-modal-input-small"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>
                <div>
                  <strong>Enddatum:</strong>
                  <input
                    type="date"
                    className="filter-modal-input filter-modal-input-small"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>
              </div>
              <div className="filter-modal-group">
                <div>
                  <strong>Pilot:</strong>
                  <select
                    value={pilot}
                    onChange={(e) => setPilot(e.target.value)}
                  >
                    <option value="">Alle</option>
                    {uniquePilots.map((pilot) => (
                      <option key={pilot.email} value={pilot.email}>
                        {pilot.prename + ' ' + pilot.lastname}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <strong>Ort:</strong>
                  {loading ? (
                    <span> Lade Orte...</span>
                  ) : (
                    <span
                      onClick={() => refreshData()}
                      className="refresh-button"
                    >
                      <span
                        className="material-symbols-outlined"
                        style={{
                          fontSize: '18px',
                          margin: '0px',
                          position: 'absolute',
                        }}
                      >
                        refresh
                      </span>
                    </span>
                  )}
                  <select
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                  >
                    <option value="">Alle</option>
                    {uniqueLocations.map((loc) => (
                      <option key={loc} value={loc}>
                        {loc}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="filter-modal-group">
                <div>
                  <strong>Einsatz:</strong>
                  <select
                    value={mission}
                    onChange={(e) => setMission(e.target.value)}
                  >
                    <option value="">Alle</option>
                    <option value="Einsatz">Einsatz</option>
                    <option value="Event">Event</option>
                    <option value="Übung">Übung</option>
                  </select>
                </div>
              </div>
              <div className="filter-modal-group">
                <button className="filter-apply-button" onClick={handleApply}>
                  Anwenden
                </button>
                <button className="filter-reset-button" onClick={handleReset}>
                  Zurücksetzen
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
